<mat-card class="detalle-conversacion-card">
  <!-- Encabezado de la conversación -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h5 class="fw-bold">{{ conversacion.usuarioNombre }}</h5>
    <div class="text-muted small">
      Último mensaje: {{ conversacion.fechaUltimoMensaje | date:'short' }} Hrs
    </div>
  </div>

  <!-- Detalle de los mensajes -->
  <div class="mensajes-container">
    <div *ngFor="let mensaje of mensajes" class="mensaje-item">
      <div
        [ngClass]="{
          'mensaje-remitente': mensaje.esRemitente,
          'mensaje-destinatario': !mensaje.esRemitente
        }"
        class="message-bubble p-2 mb-2"
      >
        <div class="small">{{ mensaje.texto }}</div>
        <div class="text-muted small text-end">{{ mensaje.fechaEnvio | date:'shortTime' }}</div>
      </div>
    </div>
  </div>

  <!-- Formulario para enviar mensajes -->
  <div class=" mt-3">
    <form [formGroup]="mensajeForm" class="enviar-mensaje-container">
      <mat-form-field appearance="outline" class="w-100" >
        <textarea 
          matInput 
          placeholder="Escribe tu mensaje" 
          formControlName="mensaje">
        </textarea>
      </mat-form-field>
      <button 
        style="margin: 30px 15px; height: fit-content;" 
          mat-raised-button 
          color="primary" 
          (click)="enviarMensaje()" 
          [disabled]="mensajeForm.invalid">
          Enviar
        </button>
    </form>
  </div>
</mat-card>
